export const IMAGE_MIME_TYPE = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/x-ms-bmp',
  'image/x-xpixmap',
];

export const VALID_PREVIEW_MIME_TYPES = [
  ...IMAGE_MIME_TYPE,
  'application/msword',
  'application/pdf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xls',
  'application/x-xls',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/excel',
];
const VECTOR_MIME_TYPES = [
  'application/dxf',
  'application/dwg',
  'image/vnd.dxf',
  'image/vnd.dwg',
];
const RASTR_MIME_TYPES = ['application/octet-stream'];
export const VALID_PREVIEW_MIME_TYPES_ON_MAP = [
  ...VECTOR_MIME_TYPES,
  ...RASTR_MIME_TYPES,
];
